import { InjectionToken } from '@angular/core';

/**
 * Cloudflare Turnstile site key. Public by design — it identifies the
 * widget in the browser; the server-side secret key is validated in the backend.
 * Provide an app-specific value to override the default per application.
 */
export const TURNSTILE_SITE_KEY = new InjectionToken<string>('TURNSTILE_SITE_KEY', {
  providedIn: 'root',
  factory: () => '0x4AAAAAADpynGqxVlTLqSUn',
});
